export default __webpack_public_path__ + "static/media/SF_Connect_Logo.7efbc6de.svg";